import { render, staticRenderFns } from "./role-search-bar.vue?vue&type=template&id=5a80679d&scoped=true"
import script from "./role-search-bar.vue?vue&type=script&lang=js"
export * from "./role-search-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a80679d",
  null
  
)

export default component.exports